import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
/////COMPONENTE DE  FORMATEAR FECHA/////
import Moment from "moment";
////COMPONENTE PARA FECHA  DatePicker/////
import DatePicker, { registerLocale } from "react-datepicker";
import * as moment from 'moment';


const modeloDatos = {
    fechaCirugiaID: 0,
    empresaID: 1,
    fechaCirugia: new Date,
    cantidadCitas: 1,
    horaDesde: "08:00:00",
    horaHasta: "09:00:00"
   
}

const FechasCirugias = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [ListaHorario, SetListadoHorario] = useState([]);

    const handleChange = (e) => {
        let value = e.target.value;
       
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "Citas/ListaFechaCirugia" + "/" + correo);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
       
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerDatosHorario();
    },[])


    const handleChangef = (e) => {
        setTabla({
            ...tabla,
            "fechaCirugia": e
        })
        obtenerDatosHorario(tabla.especialistaID)
    }
    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }

    const obtenerDatosHorario = async (e) => {
        let response = await fetch(Api + "Citas/ListaHorarioSolo");

        if (response.ok) {
            let data = await response.json()
            SetListadoHorario(data)
        }
    }


    const guardarCambios = async () => {
        let response;
        tabla.cantidadCitas = parseInt(tabla.cantidadCitas)
        tabla.fechasCirugia = Moment(tabla.fechasCirugia).format("YYYY-MM-DD")

        if (tabla.fechaCirugiaID == 0) {
        //    tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/GuardarFechaCirugia", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
         //   tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/EditarFechaCirugia", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
           obtenerDatos();  
            let data1 = await response.json()

                mostrarMensaje()
        
            
                setTabla(modeloDatos)
                setVerModal(!verModal);
   
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.fechaCirugiaID,
            sortable: true,
        },
        {
            name: 'Dia de la Cita ',
            selector: row =>Moment(row.fechaCirugia).format("DD/MM/YYYY"),
            sortable: true,
        },
       
      
        {
            name: 'Cantidad',
            selector: row => row.cantidadCitas,
            sortable: true,
          
        },    
        {
            name: 'Hora inicio',
            selector: row => row.horaDesde,
            sortable: true,
          
        },    
        {
            name: 'Hora Fin',
            selector: row => row.horaHasta,
            sortable: true,
          
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    function formatKey(date) {
        return date.toISOString().split("T")[0]; // 2025-12-05
    }

    function isSameDay(a, b) {
        return formatKey(a) === formatKey(b);
    }

    function buildCalendar(currentMonth) {
        const year = currentMonth.getFullYear();
        const month = currentMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const startingWeekDay = firstDay.getDay(); // 0 = domingo
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const cells = [];
        // huecos antes del 1
        for (let i = 0; i < startingWeekDay; i++) {
            cells.push(null);
        }
        // días reales del mes
        for (let d = 1; d <= daysInMonth; d++) {
            cells.push(new Date(year, month, d));
        }
        // completar hasta múltiplo de 7
        while (cells.length % 7 !== 0) {
            cells.push(null);
        }
        return cells;
    }


    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(null);
    const [showForm, setShowForm] = useState(false);

    const [form, setForm] = useState({
        paciente: "",
        hora: "",
        nota: "",
    });

    const [citas, setCitas1] = useState([]); // {id, dateKey, paciente, hora, nota}

    const cells = buildCalendar(currentMonth);

    const handlePrevMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() - 1,
                1
            )
        );
    };

    const handleNextMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() + 1,
                1
            )
        );
    };

    const handleDayClick = (day) => {
        if (!day) return;
        setSelectedDate(day);

        //  setShowForm(true);
tabla.fechaCirugia = day
        setVerModal(!verModal)
    };

    const handleChangeForm = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedDate) return;

        const dateKey = formatKey(selectedDate);

        setCitas1((prev) => [
            ...prev,
            {
                id: crypto.randomUUID(),
                dateKey,
                paciente: form.paciente,
                hora: form.hora,
                nota: form.nota,
            },
        ]);

        // limpiar y cerrar
        setForm({ paciente: "", hora: "", nota: "" });
        setShowForm(false);
    };

    const countCitas = (day) => {
        if (!day) return 0;
        const key = formatKey(day);
        return Listado.filter((c) => moment(c.fechaCirugia).format("YYYY-MM-DD") === key).map(x => x.cantidadCitas)[0];
       // return citas.filter((c) => c.dateKey === key).length;
    };

    const citasDelDia = selectedDate
        ? citas.filter((c) => c.dateKey === formatKey(selectedDate))
        : [];

    const monthLabel = currentMonth.toLocaleString("es-ES", {
        month: "long",
        year: "numeric",
    });

    return (
        <>
        <Card>
            <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                Lista de Fecha Cirugia
            </CardHeader>
</Card>
            <div className="calendar-wrapper" style={{color:"#000"} }>
                <div className="calendar-header">
                    <button onClick={handlePrevMonth} >{"<"}</button>
                    <h3 style={{ textTransform: "uppercase" }}>{monthLabel}</h3>
                    <button onClick={handleNextMonth}>{">"}</button>
                </div>

                <div className="calendar-weekdays">
                    {["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"].map((d) => (
                        <div key={d} className="weekday">
                            {d}
                        </div>
                    ))}
                </div>

                <div className="calendar-grid" style={{ color: "#000" }}>
                    {cells.map((day, idx) => {
                        const numCitas = day ? countCitas(day) : 0;
                        //const numCitas = day ? countCitas(day) : 0;
                        return (
                            <button
                                key={idx}
                                className={`calendar-day ${day ? "" : "empty"}`}
                                onClick={() => handleDayClick(day)}
                                disabled={!day}

                            >
                                {day && (
                                    <>
                                        <span className="day-number" style={{ color: "#000" }}>{day.getDate()}</span>
                                        {numCitas > 0 && (
                                            <div className="citas-chip">
                                                <span>{numCitas}{ day.cantidadCitas}</span>
                                                <small>citas</small>
                                            </div>
                                        )}
                                    </>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* Modal / formulario */}
                {showForm && (
                    <div className="modal-backdrop">
                        <div className="modal-box">
                            <h3>
                                Nueva cita –{" "}
                                {selectedDate &&
                                    selectedDate.toLocaleDateString("es-ES")}
                            </h3>

                            {citasDelDia.length > 0 && (
                                <div className="citas-list">
                                    <strong>Citas existentes:</strong>
                                    <ul>
                                        {citasDelDia.map((c) => (
                                            <li key={c.id}>
                                                {c.hora} - {c.paciente} ({c.nota})
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className="form-cita">
                                <label>
                                    Paciente
                                    <input
                                        name="paciente"
                                        value={form.paciente}
                                        onChange={handleChangeForm}
                                        required
                                    />
                                </label>
                                <label>
                                    Hora
                                    <input
                                        type="time"
                                        name="hora"
                                        value={form.hora}
                                        onChange={handleChangeForm}
                                        required
                                    />
                                </label>
                                <label>
                                    Nota
                                    <textarea
                                        name="nota"
                                        value={form.nota}
                                        onChange={handleChangeForm}
                                    />
                                </label>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowForm(false)}>
                                        Cancelar
                                    </button>
                                    <button type="submit">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
            <Card hidden>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Fecha Cirugia
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Fecha Cirugia</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader>
                    Mantenimiento de Fecha Cirugia
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <div className="d-flex justify-content-start">
                            <div className="p-2">
                                <Label className="citas-label">
                                    <i className="fas fa-calendar-day me-2" style={{ color: "#3e80bd" }} /> Fecha de la Cita
                                </Label>
                                <DatePicker
                                    className="form-control form-control-sm"
                                    selected={new Date(tabla.fechaCirugia)}
                                    onChange={handleChangef}
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                />
                            </div>
                            <div className="p-2">
                                <Label>Cantidad de Citas</Label>
                                <Input bsSize="sm" name="cantidadCitas" onChange={handleChange} value={tabla.cantidadCitas} />
                            </div>
                            <div className="p-2">
                                <Label className="citas-label">
                                    <i className="far fa-clock me-2" style={{ color: "#3e80bd" }} /> Hora de Inicio de la Cita
                                </Label>
                                <Input
                                    className="form-control"
                                    bsSize="sm"
                                    type="select"
                                    name="horaDesde"
                                    value={tabla.horaDesde}
                                    onChange={handleChange}
                                >

                                    {ListaHorario.map((x) => (
                                        <option key={x.horarioID} value={x.hora}>
                                            {x.hora}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                            <div className="p-2">
                                <Label className="citas-label">
                                    <i className="far fa-clock me-2" style={{ color: "#3e80bd" }} /> Hora de Finaliza de la Cita
                                </Label>
                                <Input
                                    className="form-control"
                                    bsSize="sm"
                                    type="select"
                                    name="horaHasta"
                                    value={tabla.horaHasta}
                                    onChange={handleChange}
                                >

                                    {ListaHorario.map((x) => (
                                        <option key={x.horarioID} value={x.hora}>
                                            {x.hora}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </div>
                    </FormGroup>
                   
           
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default FechasCirugias;